import { EntitledToView } from '@news-mono/web-common'
import React from 'react'
import {
    StyledFootyLivesHereLink,
    StyledFootyLivesHerePromoCard,
    StyledPromoImg,
} from './FootyLivesHerePromoCard.styled'

export type FootyLivesHerePromoCardProps = {
    use2025Images: boolean
}

export const EntitledView: React.FC<FootyLivesHerePromoCardProps> = ({
    use2025Images,
}) => {
    const promo = require('./assets/2025-AFL-Origin-Guernsey-Giveaway-Logged-In.jpg')
    const promoNew = require('./assets/2026_WA-Footy-Lives-Here-Tile-Logged-In-@1x.jpg')

    return (
        <StyledFootyLivesHerePromoCard>
            {use2025Images ? (
                <StyledPromoImg
                    src={promo}
                    alt="Your season of AFL. 2026 AFL AAMI Origin Guide available 13th February. AFL Season Preview Guide available 4th March."
                />
            ) : (
                <StyledFootyLivesHereLink to={'/originmagread'}>
                    <StyledPromoImg
                        src={promoNew}
                        alt="Your season of AFL. 2026 AFL AAMI Origin Guide available 13th February. AFL Season Preview Guide available 4th March."
                    />
                </StyledFootyLivesHereLink>
            )}
        </StyledFootyLivesHerePromoCard>
    )
}

export const OpportunityView: React.FC<FootyLivesHerePromoCardProps> = ({
    use2025Images,
}) => {
    const promo = require('./assets/2025-AFL-Origin-Guernsey-Giveaway-Logged-Out.jpg')
    const promoNew = require('./assets/2026_WA-Footy-Lives-Here-Tile-Logged-Out-@1x.jpg')
    return (
        <StyledFootyLivesHerePromoCard>
            <StyledFootyLivesHereLink to={'/sport/afl/subscribe'}>
                <StyledPromoImg
                    src={use2025Images ? promo : promoNew}
                    alt="Get a 12 month subscription to The West and receive a FREE WA AAMI AFL Origin Guernsey"
                />
            </StyledFootyLivesHereLink>
        </StyledFootyLivesHerePromoCard>
    )
}

export const FootyLivesHerePromoCard: React.FC<FootyLivesHerePromoCardProps> =
    ({ use2025Images }) => {
        return (
            <EntitledToView
                requiredAccess={{ level: 'subscriber' }}
                entitled={() => {
                    return <EntitledView use2025Images={use2025Images} />
                }}
                notEntitled={() => {
                    return <OpportunityView use2025Images={use2025Images} />
                }}
            />
        )
    }
